import {h} from 'preact'
import $ from "jquery";
import posService from "../service/posService";
import { useEffect, useState } from 'preact/hooks';
import Spinner from './Spinner';

export default function PosVerifiedPage() {
  const [isVerifying, setIsVerifying] = useState(true);
  const [verified, setVerified] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    posService.verifyUUID(urlParams.get('pos-verification'), urlParams.get('toast-email')).then((resp) => {
      if (resp.data.uuid) {
        setIsVerifying(false);
        setVerified(true);
      } else {
        setIsVerifying(false);
      }
    }).catch(() => {
      setIsVerifying(false);
    });
  }, [])

  return <div class="pos-verified">
    <div class="content">
      <img class="circle-logo" src="https://timber.mhmcdn.com/site/marketing/icons/CircleLogo.png"/>
      {isVerifying && <h1>Verifying...</h1>}
      {isVerifying && <Spinner/>}

      {!isVerifying && verified && <h1>Toast connection confirmed</h1>}
      {!isVerifying && verified && <p>MustHaveMenus email {urlParams.get('mhm-email')} is now linked to Toast email {urlParams.get('toast-email')}</p>}
      {!isVerifying && verified && <p>You may now close this tab.</p>}

      {!isVerifying && !verified && <h1>Unable to verify Toast connection</h1>}
      {!isVerifying && !verified && <p>The link may be expired.</p>}
    </div>
  </div>;
}